import type { TableDefinition } from '../engine/tables/definition';
import { createCommunityTable, getMe } from './api';
import { buildTableShareUrl } from './share';

/**
 * Guests save directly to the community backend as an unlisted table. The
 * creating browser receives an HttpOnly ownership cookie from the Worker and
 * is redirected to the portable share URL. Signed-in players continue through
 * App's existing owner-draft save flow.
 */
export async function saveGuestTableToCloud(table: TableDefinition): Promise<boolean> {
  if (typeof window === 'undefined') return false;

  try {
    const player = await getMe();
    if (player) return false;

    const created = await createCommunityTable(table);
    window.location.assign(buildTableShareUrl(created.id));
    return true;
  } catch {
    // App's existing local save path remains the offline/storage fallback.
    return false;
  }
}
